import { INSTAGRAM_STORY_MEDIA } from './instagramStoryChromeLayout';

/** Reel preview media — same width/height as story media (270×527). */
export const INSTAGRAM_REEL_MEDIA = INSTAGRAM_STORY_MEDIA;
